import { ITooltipBehavior, ITooltipBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanTooltipPresentable } from "../../../beans/objects";

export class TooltipBehaviorTranslator {
  from(bean: IObjectBeanTooltipPresentable): ITooltipBehavior {
    return {
      isEnable: (bean["@tooltip"] && (0 < bean["@tooltip"].length)),
      message: bean["@tooltip"] ? bean["@tooltip"] : "",
    };
  }

  to(o: ITooltipBehaviorSpecifiable) {
    return {
      tooltip: o.tooltipBehavior.isEnable
        ? o.tooltipBehavior.message
        : undefined,
    };
  }
}
